import React, { Suspense } from 'react'
import { maps } from './maps'

const IconMaps = ({ type, ...restProps }) => {
  const Icon = maps[type]
  if (!Icon) {
    return null
  }
  return (
    <Suspense fallback={<div>...</div>}>
      <Icon {...restProps} />
    </Suspense>
  )
}

export default IconMaps
